import React, { useState, useEffect } from "react";
import moment from "moment";
import Alarm from '../../../assets/img/dashboard/alarm';
import AlarmBell from '../../../assets/img/dashboard/alarmBell';
import Battery from '../../../assets/img/dashboard/battery';

const AlarmType = ({ selectedItem, handlePostData, action }) => {
	const [alarmVolume, setAlarmVolume] = useState(selectedItem.deviceState.alarmVolume);
	const [alarmSwitch, setAlarmSwitch] = useState(false);
	const [alarmTime, setAlaramTime] = useState(null);
	const [battery, setBattery] = useState(null);

	useEffect(() => {
		const { alarmSwitch, battery } = selectedItem.deviceState;
		setAlarmSwitch(alarmSwitch);
		setBattery(battery);
	}, [selectedItem.deviceState]);

	useEffect(() => {
		setAlarmVolume(selectedItem.deviceState.alarmVolume)
	}, [selectedItem.deviceState.alarmVolume]);

	useEffect(() => {
		setAlarmSwitch(selectedItem.deviceState.alarmSwitch);
		if(selectedItem.deviceState.alarmSwitch && selectedItem.deviceState.t) setAlaramTime(selectedItem.deviceState.t);
	}, [selectedItem.deviceState.alarmSwitch, selectedItem.deviceState.t]);

	const alarmVolumeClassName = (volume) => {
		let className = `sound-control-${volume}`;
		if( alarmVolume === volume ) className += " active";
		return className
	}

	const changeAlarmSound = () => {
		let volume = ""
		switch (alarmVolume) {
			case "low" :
				volume = "medium";
				break;
			case "medium" :
				volume = "high";
				break;
			case "high" :
				volume = "mute";
				break;
			default :
				volume = "low";
				break;
		}

		handlePostData("alarmVolume", volume);
		action();
	}

	const BatteryInfo = () => {
		let batteryLevelText = "낮음";
		if(battery >= 70) {
			batteryLevelText = "높음";
		} else if(battery >= 50) {
			batteryLevelText = "중간";
		}

		return (
			<>
				<span className="display-title-battery"> {batteryLevelText} </span>
				<span style={{"verticalAlign":"middle"}}><Battery batteryLevel={battery}/></span>
			</>
		)
	}

	const AlarmTime = () => {
		const isAfternoon = moment(alarmTime).format("HH") > 11 ? "오후" : "오전";
		return (
			<>
				<div className="detected-time-divide"></div>
				<div className="detected-time">
					<p className="detected-time-title">최근경보</p>
					<p className="detected-time-stamp">{
						alarmTime === null
							? '없음'
							: `${moment(alarmTime).format("yyyy.MM.DD")} ${isAfternoon} ${moment(alarmTime).format("hh:mm:ss")}`
					}</p>
				</div>
			</>
		)
	}

	const checkAlaramSound = () => {
		handlePostData(null, {"alarmVolume":alarmVolume, "alarmSwitch" : true}, 'alarmSwitch');
		action();
	}


	return (
		<section className="device-setting-body alaram-wrap">
			<span className="display-title">상태</span>
			<BatteryInfo />
			<div className="device-display alaram status">
				<div className="display">
					<div className="alaram-information">
						{
							<div className="detected">
								<div className={alarmSwitch ? "detected-title" : "undetected-title"}>
									{alarmSwitch ? "동작 감지" : "동작 없음" }
								</div>
								<AlarmTime />
							</div>
						}
					</div>
				</div>
			</div>
			<span className="display-title-alarm">경보 설정</span>
			<div className="device-display alaram">
				<div className="display">
					<div className="alaram-information-setting">
						<span className="sound-control">음량</span>
						<span className={alarmVolumeClassName("mute")}>무음</span>
						<span className={alarmVolumeClassName("low")}>낮음</span>
						<span className={alarmVolumeClassName("medium")}>중간</span>
						<span className={alarmVolumeClassName("high")}>높음</span>
					</div>
				</div>
			</div>
			<div className="device-control-wrap">
				<div className="alaram-control">
					<p className="alaram-sound" onClick={changeAlarmSound}>
						<span><Alarm mode={alarmVolume}/></span>
						<span>경보 음량</span>
					</p>
					<p className="alaram-test" onClick={checkAlaramSound}>
						<span><AlarmBell /></span>
						<span>울려보기</span>
					</p>
				</div>
			</div>
		</section>
	);
}

export default AlarmType;